import {
    applyCbarDateInputSubmitValues,
    getCbarDateInputSubmitValue,
    isCbarDateInput,
    restoreCbarDateInputNames,
    setupCbarDateInputHydration,
    setupExclusiveDatePopovers,
} from './common/date';
import {applyCbarCheckboxSubmitValues} from './common/checkbox';
import {
    applyCbarMultiSelectSubmitValues,
    restoreCbarMultiSelectNames,
    setupCbarMultiSelectHydration,
} from './common/multi-select';

declare global {
    interface Window {
        CBAR?: Window['CBAR'] & {
            getDateInputValue?: (target: string | Element) => string;
        };
    }
}

function resolveDateInput(target: string | Element): CbarDateInputElement | null {
    const element = typeof target === 'string' ? document.querySelector(target) : target;
    return isCbarDateInput(element) ? element : null;
}

export function setupCbarDateInputFormSubmitFix(): void {
    document.addEventListener(
        'submit',
        (event) => {
            const form = event.target;
            if (form instanceof HTMLFormElement) {
                applyCbarDateInputSubmitValues(form);
                applyCbarCheckboxSubmitValues(form);
                applyCbarMultiSelectSubmitValues(form);
            }
        },
        true
    );

    document.addEventListener('submit', (event) => {
        const form = event.target;
        if (form instanceof HTMLFormElement) {
            restoreCbarDateInputNames(form);
            restoreCbarMultiSelectNames(form);
        }
    });

    const OriginalFormData = window.FormData;
    window.FormData = function FormDataWithCbarDates(
        form?: HTMLFormElement,
        submitter?: HTMLElement
    ): FormData {
        if (form instanceof HTMLFormElement) {
            applyCbarDateInputSubmitValues(form);
            applyCbarCheckboxSubmitValues(form);
            applyCbarMultiSelectSubmitValues(form);
            const data = new OriginalFormData(form, submitter);
            restoreCbarDateInputNames(form);
            restoreCbarMultiSelectNames(form);
            return data;
        }

        return new OriginalFormData(form, submitter);
    } as typeof FormData;
    window.FormData.prototype = OriginalFormData.prototype;
}

export function setupCbarDateInputJqueryBridge(): void {
    const jq = (window as Window & { jQuery?: JQueryStatic }).jQuery;
    if (!jq) {
        return;
    }

    const origVal = jq.fn.val;
    jq.fn.val = function (this: JQuery, value?: unknown) {
        if (value === undefined && this.length > 0) {
            const results: string[] = [];
            let hasDateInput = false;

            for (let i = 0; i < this.length; i++) {
                const el = this[i];
                if (isCbarDateInput(el)) {
                    hasDateInput = true;
                    results.push(getCbarDateInputSubmitValue(el));
                }
            }

            if (hasDateInput) {
                return this.length === 1 ? results[0] : results;
            }
        }

        return origVal.apply(this, arguments as unknown as [unknown?]);
    };
}

export function setupCbarDateInputGlobals(): void {
    window.CBAR = window.CBAR ?? {};
    window.CBAR.getDateInputValue = (target: string | Element) => {
        const input = resolveDateInput(target);
        return input ? getCbarDateInputSubmitValue(input) : '';
    };
}

export function setupCbarDateInputBridge(): void {
    setupCbarDateInputFormSubmitFix();
    setupCbarDateInputJqueryBridge();
    setupCbarDateInputGlobals();
    void setupCbarDateInputHydration().then(() => {
        setupExclusiveDatePopovers(document);
    });
    void setupCbarMultiSelectHydration();
}
